import { NavLink } from 'react-router-dom'
import { Heading, SideNav, TargetLogo } from '@enterprise-ui/canvas-ui-react'

export const SideNavigation = ({ isOpen, onRequestClose }) => {
  return (
    <SideNav
      data-testid="sideNav"
      isVisible={isOpen}
      onRequestClose={onRequestClose}
    >
      <SideNav.SkipLink data-testid="sideNavSkipLink" href="#mainContent">
        Skip to Main Content
      </SideNav.SkipLink>
      <SideNav.Header data-testid="sideNavLogoHeader" as={NavLink} to={'/'}>
        <TargetLogo size="expanded" className="hc-mr-dense" />
        <Heading size={1} className="hc-fs-md">
          BPD POL
        </Heading>
      </SideNav.Header>
      <SideNav.Navigation data-testid="sideNavMainNavArea">
        <SideNav.NavigationItem as={NavLink} to={'/'} end>
          BPD Subscription Form
        </SideNav.NavigationItem>
      </SideNav.Navigation>
    </SideNav>
  )
}
